import React, { useState } from 'react';
import API_BASE_URL from './config';
import './Login.css'; // Reuse login page styling

const RequestPasswordReset = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const response = await fetch(`${API_BASE_URL}/auth/request-password-reset`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();

            if (response.ok) {
                setSuccess(true);
            } else {
                setError(data.detail || 'Failed to send reset email');
            }
        } catch (err) {
            setError('Network error. Please try again.');
            console.error('Password reset request error:', err);
        } finally {
            setLoading(false);
        }
    };

    if (success) {
        return (
            <div className="login-container">
                <div className="login-box">
                    <h2>Check Your Email</h2>
                    <div style={{ 
                        padding: '20px', 
                        background: 'var(--bg-secondary)', 
                        borderRadius: '8px',
                        marginTop: '20px',
                        textAlign: 'center'
                    }}>
                        <div style={{ fontSize: '48px', marginBottom: '20px' }}>📧</div>
                        <p style={{ color: 'var(--text-primary)', marginBottom: '10px' }}>
                            If an account exists with <strong>{email}</strong>, you will receive a password reset link shortly.
                        </p>
                        <p style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>
                            The link will expire in 1 hour.
                        </p>
                    </div>
                    <div style={{ marginTop: '20px', textAlign: 'center' }}>
                        <a href="/login" style={{ color: 'var(--primary)', textDecoration: 'none' }}>
                            ← Back to Login
                        </a>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="login-container">
            <div className="login-box">
                <h2>Reset Password</h2>
                <p style={{ color: 'var(--text-secondary)', marginBottom: '20px' }}>
                    Enter your email address and we'll send you a link to reset your password.
                </p>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="email">Email Address</label>
                        <input
                            id="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            placeholder="your.email@company.com"
                            autoComplete="email"
                            disabled={loading}
                        />
                    </div>

                    {error && (
                        <div style={{ 
                            color: '#dc3545', 
                            background: '#fff5f5',
                            padding: '10px',
                            borderRadius: '4px',
                            marginBottom: '15px',
                            fontSize: '14px'
                        }}>
                            {error}
                        </div>
                    )}

                    <button 
                        type="submit" 
                        className="login-btn"
                        disabled={loading}
                    >
                        {loading ? 'Sending...' : 'Send Reset Link'}
                    </button>
                </form>

                <div style={{ marginTop: '20px', textAlign: 'center' }}>
                    <a href="/login" style={{ color: 'var(--primary)', textDecoration: 'none' }}>
                        ← Back to Login
                    </a>
                </div>
            </div>
        </div>
    );
};

export default RequestPasswordReset;

